import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SignatureComponent } from './shared/signature/signature.component';
import { BaseComponent } from './shared/base/base.component';
import { AccountsComponent } from './profile/account/accounts.component';
import { AngularFireFunctions, AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
// Angular Material
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsModule as Ng2ChartsModule } from 'ng2-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContratoComponent } from './contrato/contrato.component';
import { InfoAcademicaComponent } from './info-academica/info-academica.component';
import { LoginComponent } from './login/login.component';
import { PagoComponent } from './pago/pago.component';
import { AcademicComponent } from './profile/academic/academic.component';
import { DocumentsComponent } from './profile/documents/documents.component';
import { ProfileComponent } from './profile/profile.component';
import { StudentComponent } from './profile/students/student.component';
import { RedsysComponent } from './redsys/redsys.component';
import { ResultkoComponent } from './resultko/resultko.component';
import { ResultokComponent } from './resultok/resultok.component';
import { FirebaseAuthComponent } from './shared/firebase-auth/firebase-auth.component';
//my modules
import { SharedModule } from './shared/shared.module';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { TutorComponent } from './tutor/tutor.component';


import { HttpClientModule } from '@angular/common/http';
import { PasswordReminderComponent } from './password-reminder/password-reminder.component';
import { EvaluationComponent } from './profile/evaluations/evaluations.component';
import { NgModule } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProfileComponent,
    TutorComponent,
    InfoAcademicaComponent,
    StudentComponent,
    AcademicComponent,
    ContratoComponent,
    PagoComponent,
    DocumentsComponent,
    AccountsComponent,
    EvaluationComponent,
    RedsysComponent,
    PasswordReminderComponent,
    ResultkoComponent,
    ResultokComponent,
    ToolbarComponent,
    SignatureComponent,
    BaseComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    SharedModule,
    NgxEchartsModule,
    NgxChartsModule,
    Ng2ChartsModule,
    AngularFireFunctionsModule,
    AngularFireStorageModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,

    // Angular Material
    MatToolbarModule,
    MatIconModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatStepperModule
  ],
  providers: [FirebaseAuthComponent, InfoAcademicaComponent, TitleCasePipe, DatePipe, AngularFireFunctions,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(library: FaIconLibrary) {
    library.addIcons(faInstagram);
  }
}
